<template>
  <div class="min-h-screen bg-gray-100">
    <!-- Header -->
    <header class="bg-white shadow">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-blue-800">Hi, {{ studentName }}</h1>
      </div>
    </header>
    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div
        class="text-left py-4 bg-white px-8 rounded-lg"
        style="font-size: 16px; line-height: 24px"
        v-html="settings ? settings.studentMessage : ''"
      ></div>
    </div>

    <main>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <!-- Loading state -->
        <div v-if="loading" class="text-center py-12">
          <div class="spinner"></div>
          <p class="mt-4 text-gray-600">Loading your surveys...</p>
        </div>

        <!-- Error state -->
        <div
          v-else-if="error"
          class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <strong class="font-bold">Error!</strong>
          <span class="block sm:inline"> {{ error }}</span>
        </div>

        <!-- Content -->
        <div v-else>
          <!-- University-level Surveys Section -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">
              University-level Module Questionnaire
            </h2>
            <div
              v-if="universityLevelSurveys.length === 0"
              class="text-center py-4 bg-white rounded-lg shadow"
            >
              <p class="text-gray-500">
                No University-level Module Questionnaire available at the
                moment.
              </p>
            </div>
            <div v-else class="grid grid-cols-1 gap-6">
              <div
                v-for="survey in universityLevelSurveys"
                :key="survey.id"
                class="bg-white overflow-hidden shadow rounded-lg border border-gray-200"
              >
                <div class="px-4 py-5 sm:p-6">
                  <div class="flex justify-between items-center">
                  <h3 class="text-lg font-medium text-gray-900 truncate">
                    {{ survey.title }}
                  </h3>
 <!--                 <span
                    :class="getStatusClass(survey.status)"
                    class="px-3 py-1 rounded-full text-sm font-semibold"
                  >
                    {{ getStatusText(survey.status) }}
                  </span>-->
                  </div>
                  <p class="mt-1 text-sm text-gray-500">
                    {{ survey.description }}
                  </p>
                  <div class="mt-4 flex items-center justify-between">
                    <span class="text-sm font-medium text-gray-500">
                      Due: {{ formatDate(survey.endDate) }}
                    </span>
                  <!--  <button
                      @click="startSurvey(survey)"
                      class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      Start Survey
                    </button>-->
                    <button
                      @click="startSurvey(survey)"
                      class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      {{ getButtonText(survey.status) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- School/Department-level Surveys Section -->
          <div>
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">
              School/Academy-level Module Questionnaire
            </h2>
            <div
              v-if="schoolDepartmentLevelSurveys.length === 0"
              class="text-center py-4 bg-white rounded-lg shadow"
            >
              <p class="text-gray-500">
                No School/Academy-level Module Questionnaire available at the
                moment.
              </p>
            </div>
            <div
              v-else
              class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2"
            >
              <div
                v-for="survey in schoolDepartmentLevelSurveys"
                :key="survey.id"
                class="bg-white overflow-hidden shadow rounded-lg border border-gray-200"
              >
                <div class="px-4 py-5 sm:p-6">
                  <div class="flex justify-between items-center">
                  <h3 class="text-lg font-medium text-gray-900 truncate">
                    {{ survey.title }}
                  </h3>
                  <span
                    :class="getStatusClass(survey.status)"
                    class="px-3 py-1 rounded-full text-sm font-semibold"
                  >
                    {{ getStatusText(survey.status) }}
                  </span>
                  </div>
                  <p class="mt-1 text-sm text-gray-500">
                    {{ survey.description }}
                  </p>
                  <p class="mt-1 text-sm text-gray-600">
                    {{ survey.department }}
                  </p>
                  <div class="mt-4 flex items-center justify-between">
                   
                    <span class="text-sm font-medium text-gray-500">
                      Due: {{ formatDate(survey.endDate) }}
                    </span>
                    <!--  <button
                      @click="startSurvey(survey)"
                      class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      Start Survey
                    </button>-->
                    <button
                      @click="startSurvey(survey)"
                      class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      {{ getButtonText(survey.status) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <StudentSurveyModal
      v-if="showSurveyModal"
      :show="showSurveyModal"
      :survey="currentSurvey"
      :student-id="studentId"
      @close="closeSurveyModal"
      @submit="submitSurvey"
    />
  </div>
</template>
  
  <script>
import { surveyApi } from "@/api/survey";
import { userStudentApi } from "@/api/user";
import StudentSurveyModal from "@/components/modals/StudentSurveyModal.vue";

export default {
  name: "StudentHomePage",
  components: {
    StudentSurveyModal,
  },
  data() {
    return {
      settings: null,
      studentName: "",
      universityLevelSurveys: [],
      schoolDepartmentLevelSurveys: [],
      loading: true,
      error: null,
      showSurveyModal: false,
      currentSurvey: null,
      studentIdFromToken: null,
    };
  },
  computed: {
    studentId() {
      return this.$route.params.studentId || this.studentIdFromToken;
    },
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case "New":
          return "bg-yellow-100 text-yellow-800";
        case "Saved":
          return "bg-blue-100 text-blue-800";
        case "Submitted":
          return "bg-green-100 text-green-800";
        default:
          return "bg-yellow-100 text-yellow-800";
      }
    },
    getStatusText(status) {
      switch (status) {
        case "New":
          return "New";
        case "Saved":
          return "Saved";
        case "Submitted":
          return "Submitted";
        default:
          return "New";
      }
    },
    getButtonText(status) {
      switch (status) {
        case "New":
          return "Enter";
        case "Saved":
          return "Enter";
        case "Submitted":
          return "Enter";
        default:
          return "Enter";
      }
    },
    async fetchStudentData() {
      try {
        if (this.studentId) {
          const studentData = await surveyApi.getStudentData(this.studentId);
          this.studentName = studentData.name;
        } else {
          const user = await userStudentApi.getProfile();
          this.studentName = user.name;
          const studentData = await surveyApi.getStudentData(user.id);
          this.studentIdFromToken = user.id;
        }
        this.settings = await surveyApi.getInstitutionSettings();
      } catch (err) {
        console.error("Error fetching student data:", err);
        this.error = "Failed to load student data. Please try again later.";
      }
    },
    async fetchAvailableSurveys() {
      try {
        this.loading = true
        const surveys = await surveyApi.getAvailableSurveysForStudent(
          this.studentId
        );
        this.loading = false
        this.universityLevelSurveys = surveys.filter(
          (survey) => survey.type === "University" && new Date(survey.startDate) <= new Date() && new Date(survey.endDate) >= new Date()
        );
        this.schoolDepartmentLevelSurveys = surveys.filter(
          (survey) => survey.type === "School/Department" && new Date(survey.startDate) <= new Date() && new Date(survey.endDate) >= new Date()
        );
      } catch (err) {
        console.error("Error fetching available surveys:", err);
        this.error = "Failed to load surveys. Please try again later.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    startSurvey(survey) {
      this.currentSurvey = survey;
      this.showSurveyModal = true;
    },
    async closeSurveyModal() {
      this.showSurveyModal = false;
      this.currentSurvey = null;
      this.loading = true
      await this.fetchAvailableSurveys();
      this.loading = false
    },
    async submitSurvey(surveyResponses) {
      try {
        // TODO: Implement API call to submit survey responses
        console.log("Submitting survey responses:", surveyResponses);
        // await surveyApi.submitSurveyResponses(this.studentId, this.currentSurvey.id, surveyResponses);
        this.closeSurveyModal();
        // Optionally, refresh the available surveys after submission
        await this.fetchAvailableSurveys();
      } catch (error) {
        console.error("Error submitting survey:", error);
        // Handle error (e.g., show error message to user)
      }
    },
  },
  async created() {
    await this.fetchStudentData();
    await this.fetchAvailableSurveys();
  },
};
</script>
  
  <style scoped>
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
  
  